import { render, staticRenderFns } from "./BtnGestorDesignado.vue?vue&type=template&id=47d518d5"
import script from "./BtnGestorDesignado.vue?vue&type=script&lang=js"
export * from "./BtnGestorDesignado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports